import {
	LANG_CONSTANTS,
	CART_CONSTANTS,
	CONFIG_CONSTANTS,
	STORE_CONSTANTS,
} from '../../store/actionTypes'
import { HELPER } from '../../utils'

const defaultProductItemState = {
	id: '',
	qty: 0,
	price: 0,
	item: [],
	category: '',
}

const initState = {
	customer_details: {
		phone_number: '',
		country_code: '',
	},
	cart_items: {
		count: 0,
		sub_total_amount: 0,
		items: [],
	},
	item_added: defaultProductItemState,
}
let cart_item, cart_item_price, product_item, sub_total_amount, cart_items, cartItemCount

const cartReducer = (state = initState, action) => {
	switch (action.type) {
		case CONFIG_CONSTANTS.SET_APP_SETTINGS_TO_DEFAULT:
			return initState
		case STORE_CONSTANTS.ACCESS_NEW_STORE:
			return {
				...state,
				cart_items: {
					count: 0,
					sub_total_amount: 0,
					items: [],
				},
				item_added: defaultProductItemState,
			}
		case CART_CONSTANTS.CLEAR_CART:
			return {
				...state,
				cart_items: {
					count: 0,
					sub_total_amount: 0,
					items: [],
				},
			}
		case CART_CONSTANTS.PHONE_NUMBER_REQUEST:
			return {
				...state,
				customer_details: action?.customer_details,
			}
		case CART_CONSTANTS.ADD_ITEM_TO_CART:
			cartItemCount = state.cart_items.items.length + 1
			cart_item = action?.cart_item
			sub_total_amount = state.cart_items?.sub_total_amount
			cart_item_price = cart_item?.selected_variant?.discounted_price * parseInt(action?.quantity)
			return {
				...state,
				item_added: {
					id: cart_item?.id,
					qty: action?.quantity ?? 1,
					price: cart_item_price,
					item: cart_item,
					category: action?.category?.name,
					variant_id: cart_item?.selected_variant?.variant_id,
				},
				cart_items: {
					...state.cart_items,
					count: cartItemCount,
					sub_total_amount: sub_total_amount === 0 ? cart_item_price : sub_total_amount,
				},
			}
		case LANG_CONSTANTS.CHANGE_LANGUAGE_LOCALE:
			return {
				...state,
				item_added: defaultProductItemState,
			}
		case CART_CONSTANTS.CLEAR_ITEMS_IN_CART:
			return {
				...state,
				item_added: defaultProductItemState,
			}
		case CART_CONSTANTS.REMOVE_ITEM_FROM_PRODUCT_ITEM:
			product_item = action?.product_removed
			return {
				...state,
				item_added:
					state?.item_added?.id === product_item?.id &&
					state?.item_added?.item?.selected_variant.variant_id ===
						product_item?.selected_variant.variant_id
						? defaultProductItemState
						: state?.item_added,
			}
		case CART_CONSTANTS.CHANGE_ITEM_QTY_IN_CART:
			cart_item = action?.cart?.cart_items
			return {
				...state,
				cart_items: {
					count: cart_item.length,
					sub_total_amount: action?.cart?.sub_total_amount,
					items: cart_item,
				},
			}
		case CART_CONSTANTS.UPDATE_CART:
			sub_total_amount = 0
			cart_item = {
				product: action.payload || state.item_added.item,
				qty: action.payload ? 1 : parseInt(state.item_added.qty),
				price: action.payload?.price || parseFloat(state.item_added.price),
				category: action.payload?.category || state.item_added?.category,
				variant_id: action.payload?.variant_id || state.item_added?.variant_id,
			}
			cart_items = HELPER.addObjectToCollection(cart_item, state.cart_items.items)
			cart_items.map((item) => {
				sub_total_amount += item.price
				return true
			})
			return {
				...state,
				cart_items: {
					...state.cart_items,
					// count: (cart_item).length,
					sub_total_amount: sub_total_amount,
					items: cart_items,
				},
			}
		case CART_CONSTANTS.UPDATE_CART_LOCALE_REQUEST:
			return {
				...state,
				cart_items: {
					count: action?.cart_items?.count,
					items: action?.cart_items?.updated_cart_items,
					sub_total_amount: action?.cart_items?.sub_total_amount,
				},
			}
		default:
			return state
	}
}

export default cartReducer
